<template>
  <div :class="[formStep === 3 ? 'mx-auto' : 'player-registration-form']">
    <PlayerRegistrationFormPlayerDetails
      v-if="formStep === 1"
      :moveToFormStep="moveToFormStep"
    />
    <PlayerRegistrationFormPaymentDetails
      v-if="formStep === 2"
      :moveToFormStep="moveToFormStep"
    />
    <PlayerRegistrationFormConfirmation
      v-if="formStep === 3"
      :moveToFormStep="moveToFormStep"
    />
  </div>
</template>

<script>
import PlayerRegistrationFormPlayerDetails from "./PlayerRegistrationFormPlayerDetails";
import PlayerRegistrationFormPaymentDetails from "./PlayerRegistrationFormPaymentDetails";
import PlayerRegistrationFormConfirmation from "./PlayerRegistrationFormConfirmation";

export default {
  name: "PlayerRegistrationForm",
  props: {
    formStep: {
      type: Number,
      required: true
    },
    moveToFormStep: {
      type: Function,
      required: true
    }
  },
  components: {
    PlayerRegistrationFormConfirmation,
    PlayerRegistrationFormPlayerDetails,
    PlayerRegistrationFormPaymentDetails
  }
};
</script>

<style scoped>
.player-registration-form {
  width: 600px;
  padding: 0 12px;
}
@media (min-width: 960px) {
  .player-registration-form {
    padding: 0;
    min-width: 600px;
    flex-basis: 40%;
  }
}
@media (max-width: 600px) {
  .player-registration-form {
    max-width: 100%;
  }
}
</style>
